<div class="w-100 mb-3" style="text-align: left; display: flex; align-items: center; ">
  <mat-checkbox [(ngModel)]="innerValue" [color]="'radial-primary'" [disabled]="disabled">
    {{label}}
  </mat-checkbox>
  <span mat-raised-button #idTooltip="matTooltip" [matTooltip]="tooltip" matTooltipPosition="right" (click)="idTooltip.show()" class="tooltip-input-icon">
    <i class="bi bi-info-circle-fill"></i>
  </span>
</div>
